import { Component, inject } from '@angular/core';
import {
  FormGroup,
  FormControl,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';

import { AuthService } from '../../auth.service';

@Component({
  selector: 'app-login',
  imports: [ReactiveFormsModule],
  templateUrl: './login.component.html',
  styles: '',
})
export class LoginComponent {
  private authService = inject(AuthService);
  private router = inject(Router);

  loginForm = new FormGroup({
    username: new FormControl('', Validators.required),
    password: new FormControl('', Validators.required),
  });

  errorMessage = '';

  submit() {
    this.authService.login(this.loginForm.value).subscribe({
      next: (response: any) => {
        if (response.ok) {
          this.authService.setAccessToken(response.body?.access_token);
          this.router.navigate(['/']);
        }
      },
      error: (error: any) => {
        if (error.status === 401) {
          this.errorMessage = error.error.message;
        } else {
          this.errorMessage = 'Error inesperado. Intente nuevamente.';
        }

        this.clearForm();
      },
    });
  }

  clearForm() {
    this.loginForm.reset({
      username: '',
      password: '',
    });
  }
}
